import { useEffect } from 'react'

const ORIGIN = 'https://getmauj.com'

/** Sets the tab title and, when a path is given, the canonical and share URLs for this page. */
export function useTitle(title: string, path?: string) {
  useEffect(() => {
    document.title = title
    // Without an explicit path (404 and error pages), point at the address actually shown, never a previous page.
    const url = `${ORIGIN}${path ?? window.location.pathname}`
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', url)
    document.querySelector('meta[property="og:url"]')?.setAttribute('content', url)
    document.querySelector('meta[property="og:title"]')?.setAttribute('content', title)
  }, [title, path])
}
